import customEventListeners from './custom-event-listeners';
import eventListeners from './event-listeners';

export default {
  customEventListeners,
  eventListeners,
};
